const newsletter_triggers = document.querySelectorAll(".btn--newsletter, a[href='#triggerNewsletter']");
const body = document.querySelector('body')
const noPhoneNumberCheckbox = document.querySelector('.no_phone_number');
const phoneNumberLabel = document.querySelector('.phone-wrapper .phone-number');
const isCustomer = window.theme && window.theme.customer && window.theme.customer.id ? true : false;

function getNewsletterPopup() {
    return document.getElementById("newsletter-popup")
}
function getNewsletterPopupOverlay() {
    return document.querySelector('.newsletter-overlay')
}

function triggerNewsletterPopup(event) {
    event.preventDefault();
    if (isCustomer) {
        // @TODO: Fix this so it launches the my account sidebar
        document.dispatchEvent(new CustomEvent('account:open', {
            detail: {
                tab: "marketing-preferences",
            }
        }));
    } else {
        getNewsletterPopup().classList.add('active');
        getNewsletterPopupOverlay().classList.add('active');
        body.style.overflow = 'hidden';
    }
}

newsletter_triggers.forEach(trigger => {
    trigger.addEventListener("click", triggerNewsletterPopup);
});

noPhoneNumberCheckbox.addEventListener('change', function () {
    if (this.checked && phoneNumberLabel.classList.contains('error')) {
        phoneNumberLabel.classList.remove('error');
    }
});

function showNewsletterMessage(element, message) {
    if (message.includes('You can add your phone number here.')) {
        element.html(`
            ${message.replace('here.', '')} <a href="#" class="btn--navigate" data-tab="personal-details" data-open="true">here.</a>
        `)
        element.find('.btn--navigate').click(function () {
            getNewsletterPopup().classList.remove('active')
            getNewsletterPopupOverlay().classList.remove('active')
        })
    } else {
        element.find('.error-message').text(message);
    }
    element.show();
}

$('#customerNewsletter').on('submit', function (e) {
    e.preventDefault();
    const form = $(this);

    const checkNewletterValidation = (event) => {
        const event_detail = event.detail;

        if (event_detail.status) {
            const spinner = form.find('.spinner-container');
            const form_action = form.attr('action');
            const is_customer = form_action.includes('/customer') ? true : false;

            const emailCheckedBox = form.find("input[name='customer[accepts_marketing]']").is(':checked');
            const smsCheckedBox = form.find("input[name='customer[accepts_sms]']").is(':checked');

            spinner.show();

            let formData = null
            if (is_customer) {
                formData = {
                    shop: Shopify.shop,
                    acceptsMarketing: emailCheckedBox,
                    smsConsent: smsCheckedBox,
                };
            } else {
                formData = {
                    shop: Shopify.shop,
                    email: form.find("input[name='customer[email]']").val(),
                    firstName: form.find("input[name='customer[first_name]']").val(),
                    lastName: form.find("input[name='customer[last_name]']").val(),
                    dateOfBirth: form.find("input[name='dob']").val().split('-').reverse().join('/'),
                    phone: form.find("input[name='customer[phone_number]']").val(),
                    no_phone_number: form.find("input[name='no_phone_number']").is(':checked'),
                    acceptsMarketing: emailCheckedBox,
                    smsConsent: smsCheckedBox
                };
            }

            $.ajax({
                type: is_customer ? 'PATCH' : 'POST',
                url: form.attr('action'),
                data: JSON.stringify(formData),
                contentType: 'application/json',
                success: function (response) {
                    if (response.ok === true) {
                        form.find('.success__signup').css({ 'background-color': '#DDF3F1', 'color': '#1D1D1B' });
                        if (isCustomer) {
                            form.find('.success__signup .message').text("Your preferences have been updated.");
                        } else {
                            form.find('.success__signup .message').text("You have been signed up to our newsletter.");
                        }
                        form.find('.success__signup').css("display", "block");
                        form.find('.error__signup').hide();
                        setTimeout(function () {
                            form.find('.success__signup').hide();
                            getNewsletterPopup().classList.remove('active');
                            getNewsletterPopupOverlay().classList.remove('active')

                            window.scrollTo({
                                top: 0,
                                behavior: 'smooth'
                            });

                            if (!is_customer)
                                form[0].reset()
                        }, 3000);
                    } else {
                        showNewsletterMessage(form.find('.error__signup'), response.message);
                        form.find('.success__signup').hide();
                        console.error(response);
                    }

                    spinner.hide();
                },
                error: function (error) {
                    showNewsletterMessage(form.find('.error__signup'), theme.strings.genericError);
                    form.find('.success__signup').hide();
                    console.error(error);

                    spinner.hide();
                }
            });
        } else {
            setTimeout(function () {
                form.find('.form-label.error').addClass('form-label--shake')
                setTimeout(function () {
                    form.find('.form-label.error').removeClass('form-label--shake')
                }, 1000)
            }, 1000);

            form.find('.success__signup').hide();
            form.find('.error__signup').hide();
        }

        document.removeEventListener('form:validation', checkNewletterValidation, false);
    }

    document.addEventListener('form:validation', checkNewletterValidation);
});
